import React from 'react'
import { getFileExtension } from './util'
import Head from 'next/head'
import { OG_IMAGE_EXTENSIONS } from './constants'

export type MetaTagsProps = {
    generalData?: GeneralProps
    twitterData?: TwitterProps
    ogData?: OgProps
}

export type GeneralProps = {
    title?: string
    keyword?: string
    description?: string
    canonicalUrl?: string
}

export type TwitterProps = {
    title?: string
    description?: string
    url?: string
    card?: string
    image?: string
    site?: string
    creator?: string
}

export type OgProps = {
    title?: string
    description?: string
    url?: string
    siteName?: string
    image?: string
    imageAlt?: string
    imageType?: string
    imageWidth?: number
    imageHeight?: number
}

export const CommonMetaTags = ({
    generalData,
    twitterData,
    ogData
}: MetaTagsProps): JSX.Element => {
    const imageExtension = getFileExtension(ogData?.image!)

    return (
        <Head>
            <title>{generalData?.title}</title>
            <meta name="title" content={generalData?.title} />
            <meta name="keywords" content={generalData?.keyword} />
            <meta name="description" content={generalData?.description} />
            <link rel="canonical" href={generalData?.canonicalUrl} />
            {/* TWITTER */}
            <meta name="twitter:title" content={twitterData?.title} />
            <meta
                name="twitter:description"
                content={twitterData?.description}
            />
            <meta property="twitter:creator" content={twitterData?.creator} />
            <meta property="twitter:site" content={twitterData?.site} />
            <meta property="twitter:url" content={twitterData?.url} />
            <meta name="twitter:card" content={twitterData?.card} />
            <meta name="twitter:image" content={twitterData?.image} />
            {/* OPEN GRAPH */}
            <meta property="og:url" content={ogData?.url} />
            <meta property="og:title" content={ogData?.title} />
            <meta property="og:description" content={ogData?.description} />
            <meta property="og:image" content={ogData?.image} />
            <meta property="og:image:alt" content={ogData?.imageAlt} />
            <meta
                property="og:image:width"
                content={String(ogData?.imageWidth)}
            />
            <meta
                property="og:image:height"
                content={String(ogData?.imageHeight)}
            />
            {OG_IMAGE_EXTENSIONS.includes(imageExtension) && (
                <meta
                    property="og:image:type"
                    content={`image/${imageExtension}`}
                />
            )}
            <meta property="og:site_name" content={ogData?.siteName} />
        </Head>
    )
}
